import type { CommentsChannelView } from '~publish/legacy/routes'

import type { CommunityTab } from '../types'

/**
 * Type guard to check if a value is a valid CommunityTab
 */
export const isValidCommunityTab = (
  value: string | null,
): value is CommunityTab => {
  return value === 'comments' || value === 'mentions' || value === 'dms'
}

/**
 * Type guard to check if a value is a valid CommentsChannelView
 */
export const isValidCommentsChannelView = (
  value: string | undefined,
): value is CommentsChannelView => {
  return value === 'comments' || value === 'posts'
}
